import { keyframes } from "@mui/material";
export const fadeInSlideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;
//# sourceMappingURL=utils.js.map